import { useMemo } from "react";
import { useLocation } from "react-router-dom";
export var useURLParam = function (param) {
    var _a;
    var search = useLocation().search;
    var params = useMemo(function () { return new URLSearchParams(search); }, [search]);
    return (_a = params.get(param)) !== null && _a !== void 0 ? _a : undefined;
};
